import {
  distributePositionCoord,
  type SeatLayoutProfile,
} from 'constants/seatLayout';
import ShufflerShoe from 'components/table/ShufflerShoe';

interface DistributorTrayProps {
  isDealing?: boolean;
  layoutProfile?: SeatLayoutProfile;
}

/** Dealer shoe on the top leather rail — cards deal from here */
export default function DistributorTray({
  isDealing,
  layoutProfile = 'desktop',
}: DistributorTrayProps) {
  const active = Boolean(isDealing);
  const position = distributePositionCoord(layoutProfile);

  return (
    <div
      className="tp-distributor-tray-anchor pointer-events-none absolute z-[41]"
      style={{
        left: `${position.x}%`,
        top: `${position.y}%`,
      }}
      aria-hidden
    >
      <ShufflerShoe active={active} />
    </div>
  );
}
